import { render, staticRenderFns } from "./ThreeDotsIcon.vue?vue&type=template&id=759a204e"
import script from "./ThreeDotsIcon.vue?vue&type=script&lang=js"
export * from "./ThreeDotsIcon.vue?vue&type=script&lang=js"
import style0 from "./ThreeDotsIcon.vue?vue&type=style&index=0&id=759a204e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports